import { Pipe, PipeTransform } from '@angular/core';
import { formatNumber } from '../helpers/formatNumbers';

@Pipe({
  name: 'shortNumber',
})
export class ShortNumberPipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    if (value === null || value === undefined) {
      return '';
    }
    return formatNumber(value);
  }
}
